<script setup>
import { onMounted, ref } from 'vue'
import { MESSAGES } from '../messages'
import { Gems } from "@/gems"
import { KNOLIA } from '../knolia'

const participationLevel = ref([])
const proficiencyLevel = ref([])

async function GetTable(get, table) {
    const res = await KNOLIA.CallBackEnd("get", "get-operations", {
        params: {
            get: get,
        }
    })

    table.value = res.data
}

async function SaveTable(set, data) {
    if(!ListIsValid(data))
        return

    const res = await KNOLIA.CallBackEnd("post", "set-operations&get=" + set, {
        params: {
            data
        }
    })

    if(res.error)
        Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
    else
        Gems.Telegram(MESSAGES.SUCCESS.SAVED, 'tele-success')
}

function ListIsValid(element) {
    let valid  = true

    element.forEach(row => {
        row.errorMin = false
        if(FieldIsInvalid(row.min)){
            Gems.Telegram(MESSAGES.ERROR.NOT_ALLOWED, 'tele-not-allowed')
            row.errorMin = true
            valid = false
        }
        
        if(row?.ideal) {
            row.errorIdeal = false
            if(FieldIsInvalid(row.ideal)){
                Gems.Telegram(MESSAGES.ERROR.NOT_ALLOWED, 'tele-not-allowed')
                row.errorIdeal = true
                valid = false
            }
        }

        if(row?.min && row?.ideal) {
            row.errorIdeal = false
            if(parseInt(row.ideal) <= parseInt(row.min)){
                Gems.Telegram(MESSAGES.ERROR.NOT_ALLOWED, 'tele-not-allowed')
                row.errorIdeal = true
                valid = false
            }
        }
    })

    return valid
}

function FieldIsInvalid(value) {
    const reg = new RegExp('^\\d+$')
    return !reg.test(value) || value > 36 || value < 0
}

function ShowParticipationScale(id) {
    const divParticipationScale = document.getElementById(id)

  if (divParticipationScale.children.length > 1) {
    window.CloseParticipationScale(id)
  } else {
    const div = document.createElement("div")
    divParticipationScale.appendChild(div)

    // div.innerHTML += `<i class='bi bi-x-lg close-scale' onclick='CloseParticipationScale(${id})'></i>`;
    div.innerHTML += "<div class='participation-scale-img'>"
    div.setAttribute("class", "div-participation-scale")
  }
}

window.CloseParticipationScale = (id) => {
  document.getElementById(id).removeChild(document.getElementById(id).lastElementChild)
}

onMounted(async () => {
    await GetTable("participation-level", participationLevel)
    await GetTable("proficiency-level", proficiencyLevel)
})
</script>

<template>
  <div class="page-container">
    <h1 class="font-bold mb-4 fs-2 div-default-title">Proficiências para o nível de participação</h1>
    <div class="d-flex gap-5">
        <div>
            <div class="div-table default-radius">
                <div class="row">
                    <span class="p-2 span-table-title fw-bold fs-5 text-center">Nível de participação</span>
                </div>
                <div class="row">
                    <div class="col-5 p-2 fw-bold">Participação</div>
                    <div class="col-4 p-2 text-center fw-bold">Mínimo</div>
                    <div class="col-3 p-2 text-center fw-bold">Padrão</div>
                </div>
        
                <div class="row" v-for="item in participationLevel" :key="item.level">
                    <div class="col-5 p-2 fw-bold">
                        <span :class="{'input-error': item.errorMin || item.errorIdeal}">{{ item.designation }}</span>
                    </div>
                    <div class="col-4">
                        <input type="text" v-model="item.min" class="text-center input-participation" :class="{'input-error': item.errorMin}"/>
                    </div>
                    <div class="col-3">
                        <input type="text" v-model="item.ideal" class="text-center input-participation" :class="{'input-error': item.errorIdeal, 'gap-value': item.level == 3}"/>
                    </div>
                </div>
            </div>
        
            <button class="btn-save-participation ddl-alt-padding" @click="SaveTable('participation-level', participationLevel)">Gravar</button>

            <div class="div-gap-hint"> [{{ participationLevel[2]?.ideal }}] Valor de referência para os gaps</div>
        </div>

        <div>
            <div id="1" class="div-excel-instructions">
            <div class="icon-container">
                <i class="fas fa-info-circle icon cursor-pointer" @click="ShowParticipationScale(1)"></i>
                <span>Escala de proficiência</span>
            </div>
        </div>
        </div>
    </div>
  </div>
</template>

<style>
    
.div-participation-scale {
  font-size: 0.8em;
  background-color: #404d6dcc;
  backdrop-filter: blur(10px);
  position: absolute;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  max-height: 650px;
  min-height: 20px;
  max-width: 610px;
  min-width: 290px;
  z-index: 10;
}

.div-participation-scale li {
  margin-left: 15px;
}

.close-scale {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 1.3em !important;
  cursor: pointer;
  border: none !important;
  width: 10px !important;
  height: 10px !important;
  background-color: transparent;
}

.close-scale:hover {
  color: var(--default-app-hover-color) !important;
  position: absolute;
  background-color: transparent !important;
}

.participation-scale-img {
  display: block;
  height: 430px;
  width: 400px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("../images/proficiency_scale.jpg");
  background-size: contain;
}
</style>

<style scoped>
    .div-table {
        width: 300px;
        border-radius: 5px;
        border: 1px solid;
    }

    .span-table-title {
        width: 100%;
    }

    .row:nth-child(n + 2) {
        border-top: 1px solid;
    }

    .col {
        padding: 0px !important;
    }

    .div-designation {
        width: 100px;
    }
    
    .input-participation {
        width: 100%;
        height: 100%;
        border-radius: 0px !important;
        border: 0px;
        cursor: pointer;
        padding: 0px !important;
    }

    .btn-save-participation {
        margin-top: 5px;
        width: 300px;
    }

    .input-error {
        color: orangered !important;
    }

    .gap-value,
    .div-gap-hint {
        color:orange !important;
        font-weight: bold;
    }

    .div-gap-hint {
        margin: 5px 0px;
    }

    .icon-container {
        display: flex;
        align-items: center;
    }

    .icon-container>span {
        font-weight: bold;
    }

    .icon {
        font-size: 1.3em;
        cursor: pointer;
        margin-right: 5px;
    }
</style>